// NEW: UI_REVAMP
import { Box, Button, Flex, useDisclosure } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { severAxiosInstance } from '../../api/query/api';
import { getSuppKeyApi } from '../../api/query/authApi';
import { getCreditRemainApi } from '../../api/query/profileApi';
import { useBottomSheetStore } from '../../hooks/useBottomSheetStore';
import ImgComp from '../../utils/ImgComp';
import UiBlock from '../../utils/UiBlock';
import { MobileSideBar } from '../drawer/MobileSidebar';
import LogoutModal from '../modal/LogoutModal';
import BalancePill from './BalancePill';
import Logo from './Logo';

const MobileToggleHeader = ({ isAgent = false, setDate, isResultScreen }) => {
	//bottomSheet
	const activeSheet = useBottomSheetStore((s) => s.activeSheet);
	const isBottomSheetOpen = activeSheet !== null;
	// useState
	const [isOpen, setIsOpen] = useState(false);
	const [isLogout, setIsLogout] = useState(false);
	const [jsParseLocal, setJsParseLocal] = useState();

	// modal
	const {
		isOpen: isOpenResultPage,
		onOpen: onOpenResultPage,
		onClose: onCloseResultPage,
	} = useDisclosure();

	//* api
	const getCreditRemain = useQuery(['getCreditRemainApi'], getCreditRemainApi, { enabled: false });
	const getSuppKey = useQuery(['getSuppKeyApi'], getSuppKeyApi, { enabled: false });

	// function
	const toggleDrawer = () => {
		setIsOpen(!isOpen);
		if (window.smartsupp) {
			window.smartsupp(function () {
				const container = document.getElementById('smartsupp-widget-container');
				if (container && container.firstElementChild) {
					container.firstElementChild.style.zIndex = '999';
				}
				const widget = document.getElementById('widgetButtonFrame');
				if (widget && widget.firstElementChild) {
					widget.firstElementChild.style.zIndex = '999';
				}
			});
		}
	};

	// useEffect
	useEffect(() => {
		severAxiosInstance.defaults.headers.common.Authorization =
			'Bearer ' + sessionStorage.getItem('accessToken');

		if (
			sessionStorage.getItem('accessToken') !== null &&
			sessionStorage.getItem('accessToken') !== undefined
		) {
			getCreditRemain.refetch();
			getSuppKey.refetch();
		}
	}, [sessionStorage.getItem('accessToken')]);

	useEffect(() => {
		if (getSuppKey.isSuccess && getSuppKey.data) {
			if (localStorage.getItem(`ssupp_${getSuppKey.data?.data?.string}`)) {
				setJsParseLocal(JSON.parse(localStorage.getItem(`ssupp_${getSuppKey.data?.data?.string}`)));
			}
		}
	}, [
		getSuppKey.isSuccess,
		getSuppKey.data,
		localStorage.getItem(`ssupp_${getSuppKey.data?.data?.string}`),
	]);

	useEffect(() => {
		const handleResize = () => {
			setIsOpen(false);
		};
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const isBetStatus = false; // DO NOT REMOVE THIS UNTIL API INTEGRATION IS DONE

	return (
		<>
			<Box
				bg={isBottomSheetOpen ? '' : 'linear-gradient(180deg, #C5C3FE 0%, #EBEAFF 69.48%)'}
				display={isBetStatus ? 'none' : { base: 'flex', lg: 'none' }}
				justifyContent='space-between'
				alignItems='center'
				p={3}
			>
				<Logo />
				<Flex alignItems='center' justifyContent='end' gap={2.5}>
					{!isResultScreen ? <BalancePill /> : null}

					<Button
						onClick={toggleDrawer}
						bgGradient='linear-gradient(180deg, #8CB3F5 0%, #0A54EF 100%)'
						minW={0}
						p={0}
						w={8}
						h={8}
						borderRadius='full'
					>
						<ImgComp svgName={'hamburger'} w='18px' h='auto' />
					</Button>
				</Flex>
			</Box>

			<>
				<MobileSideBar
					setIsOpen={setIsOpen}
					isOpen={isOpen}
					toggleDrawer={toggleDrawer}
					setDate={setDate}
					isAgent={isAgent}
					onClickLogout={() => {
						setIsOpen(false);
						setIsLogout(true);
						if (window.smartsupp) {
							window.smartsupp(function () {
								const container = document.getElementById('smartsupp-widget-container');
								if (container && container.firstElementChild) {
									container.firstElementChild.style.zIndex = '999';
								}
								const widget = document.getElementById('widgetButtonFrame');
								if (widget && widget.firstElementChild) {
									widget.firstElementChild.style.zIndex = '999';
								}
							});
						}
					}}
					onOpenResultPage={onOpenResultPage}
					isOpenResultPage={isOpenResultPage}
					onCloseResultPage={onCloseResultPage}
				/>

				{isOpen ? <UiBlock /> : null}
			</>

			<LogoutModal
				isOpen={isLogout}
				onClose={() => setIsLogout(false)}
				jsParseLocal={jsParseLocal}
			/>
		</>
	);
};

export default MobileToggleHeader;
